// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2x5WG","containerItemsCenter":"Skeleton_containerItemsCenter__AWdc1"};